<template>
  <div class="fast-survey">
    <div class="row">
      <div class="col-md-12 top">
        <router-link
          class="return"
          :to="{
            name: 'ListDiagnostic'
          }"
        >
          <i class="fas fa-chevron-left"></i>
          {{ $t("events.newEvent.back") }}.
        </router-link>
      </div>
    </div>
    <h1 >
      {{
      this.$route.params.nameDesing ? this.$route.params.nameDesing :  this.infoSurvey.name ? this.infoSurvey.name : $t("surveys.newSurvey.titleSurvey")
      }}
    </h1>
    <div v-if="isActiveAlert">
      <b-alert
        v-model="isActiveAlert"
        variant="danger"
        dismissible
        id="alert"
        >{{ $t("surveys.emptyAlert") }}</b-alert
      >
    </div>
     <!-- Usuarios seleccionados -->
    <div class="input-container recipients">
      <label class="font-b" for="alertPriority">{{
        $t("newAlert.users")
      }}</label>
      <br />
      <router-link
        v-if="this.surveyPercentAnswer === 0"
        :to="{
          name: 'User Search',
          params: {
            date1: this.date1,
            time1: this.time1,
            date2: this.date2,
            time2: this.time2,
            questions: this.questions,
            surveyTime: this.surveyTime,
            surveyDescription:this.surveyDescription,
            nameDesing:this.$route.params.nameDesing,
            typeAccion:this.$route.params.typeAccion,
            typeTemplate:this.$route.params.typeTemplate,
            cmsUserFilter: 'collaborator',
            surveyType: this.$route.params.surveyType,
            controlNumbers: this.users,
            id: getSurveyId,
            surveyObj: this.$route.params.surveyObj,
            survey: {
              fastQuestion: this.fastQuestion,
              surveyDescription: this.surveyDescription,
              answer1: this.answer1,
              color1: this.color1,
              answer2: this.answer2,
              color2: this.color2,
              date1: this.date1,
              time1: this.time1,
              date2: this.date2,
              time2: this.time2,
              surveyTime: this.surveyTime,
              sendNotification: this.sendNotification,
              questions: this.questions
            }
          },
          query: {
            path: this.$route.name
          }
        }"
        >{{ $t("newAlert.users_select") }} ></router-link
      >
      <p v-if="users && users !== '*'">
        {{ users.length }} {{ $t("newAlert.users_selected") }}
      </p>
      <p v-else>{{ $t("newAlert.users_all") }}</p>
    </div>
    <!-- Usuarios seleccionados -->
    <p
      
      class="mt-3"
    >
      {{ $t("surveys.newSurvey.fastSurvey.fastSurveyBody") }}
    </p>
   
    
    <p class="black">{{ $t("events.newEvent.requireFields") }}</p>
    <form class="mt-5">
      <label class="font-b" v-if="$route.params.surveyType === 'quickSurvey'"
        >{{ $t("surveys.newSurvey.fastSurvey.enterQuestion") }} (*)</label
      >
      <input
        type="text"
        v-model="fastQuestion"
        placeholder="Pregunta"
        v-if="$route.params.surveyType === 'quickSurvey'"
        :disabled="this.surveyPercentAnswer !== 0"
      />
      <label class="font-b" v-if="$route.params.surveyType !== 'quickSurvey'"
        >{{ $t("surveys.newSurvey.description") }} (*)</label
      >

      <input
        type="text"
        :placeholder="$t('surveys.newSurvey.description') "
        v-if="$route.params.surveyType !== 'quickSurvey'"
        v-model="surveyDescription"
        :disabled="this.surveyPercentAnswer !== 0"
      />

      <div
        class="collapse-section mt-5"
        v-if="$route.params.surveyType !== 'quickSurvey'"
      >
        <div>
          <b-card
            v-for="(item, index) in questions"
            :key="index"
            no-body
            class="mb-4 vs-collapse"
          >
            <b-card-header
              header-tag="header"
              class="p-1"
              role="tab"
              v-b-toggle="'accordion-' + index"
            >
              <p id="titleQuestion">{{ item.title }}</p>
              
              <p>
                <small class="gray" id="type">{{ $t("diagnostic.modal.category") }}: {{ item.categoryName }}</small>
              </p>
              <p>
                <small class="gray" id="type">{{ item.type }}</small>
              </p>
            </b-card-header>
            <div
              class="icons"
              :class="{ desaparecer: surveyPercentAnswer !== 0 }"
            >
              <i
                class="far fa-edit"
                @click="openEditModal(index, item.title)"
              ></i>
              <i class="far fa-trash-alt" @click="openDeleteModal(index)"></i>
            </div>
            <b-collapse
              visible
              :id="'accordion-' + index"
              accordion="my-accordion"
              role="tabpanel"
            >
              <!--Div para opcion multiple y check-->
              <div
                v-if="
                  item.numberType === 'radio_button' ||
                    item.numberType === 'multiple_option'
                "
                class="multiple"
              >
                <div
                  v-for="(nuevo, index2) in item.multipleOptionItems"
                  :key="index2"
                >
                  <div
                    ref="mydiv"
                    class="input-option multi-input"
                    :id="'elem-' + index2"
                  >
                    <label class="font-b">
                      {{ $t("surveys.newSurvey.fastSurvey.option") }}
                      {{ +index2 + 1 }} (*)
                    </label>
                    <i
                      :class="{
                        'far fa-circle': item.numberType === 'radio_button',
                        'fas fa-check-square':
                          item.numberType === 'multiple_option'
                      }"
                    ></i>
                    <input
                      type="text"
                      v-model="
                        questions['question' + item.index].multipleOptionItems[
                          index2 + ''
                        ].name
                      "
                      :disabled="surveyPercentAnswer !== 0"
                    />
                    <span
                      v-if="index2 > 2"
                      class="remove"
                      :class="{ desaparecer: surveyPercentAnswer !== 0 }"
                      @click="removeMultiOptionInput(index2, item)"
                      >- Remover opción</span
                    >
                  </div>
                </div>
              </div>
              <div
                v-if="
                  item.numberType === 'radio_button' ||
                    item.numberType === 'multiple_option'
                "
                class="add-option"
              >
                <span
                  :class="{ desaparecer: surveyPercentAnswer !== 0 }"
                  @click="addMultiOptionInput(item)"
                  >+ Agregar opción</span
                >
              </div>
              <!--Div para opcion multiple y check-->
              <!--Div switch-->
              <div v-if="item.numberType === 'binary'" class="switch">
                <div class="input-option">
                  <label class="font-b"
                    >{{ $t("surveys.newSurvey.fastSurvey.option") }} 1
                    (*)</label
                  >
                  <input
                    type="text"
                    v-model="
                      questions['question' + item.index].multipleOptionItems[
                        '0'
                      ].name
                    "
                    :disabled="surveyPercentAnswer !== 0"
                  />
                </div>
                <div class="img">
                  <img src="../../assets/img/icon/icon_switch.svg" alt />
                </div>
                <div class="input-option">
                  <label class="font-b"
                    >{{ $t("surveys.newSurvey.fastSurvey.option") }} 2
                    (*)</label
                  >
                  <input
                    type="text"
                    v-model="
                      questions['question' + item.index].multipleOptionItems[
                        '1'
                      ].name
                    "
                    :disabled="surveyPercentAnswer !== 0"
                  />
                </div>
              </div>
              <!--Div switch-->
              <!--Div open cuestion-->
              <div v-if="item.numberType === 'open'" class="open-question">
                <div class="text-area-option">
                  <label>Comentarios adicionales</label>
                  <br />
                  <textarea
                    cols="20"
                    rows="5"
                    disabled="true"
                    placeholder="Escribe"
                  ></textarea>
                </div>
              </div>
              <!--Div open cuestion-->
              <!--Div open stars-->
              <div v-if="item.numberType === 'number'" class="stars">
                <img
                  src="@/assets/img/icon/stars.png"
                  alt
                  title="Los usuarios podrán contestar en una escala del 0 al 5, en intervalos de 0.5. "
                />
              </div>
              <!--Div open Slider-->

              <div v-if="item.numberType === 'range'" class="stars">
                <img src="@/assets/img/icon/slider.png" alt />
              </div>
              <!-- Div open emoticons -->
              <div v-if="item.numberType === 'emoji'" class="emoticons">
                <div class="sentimiento-section mb-3">
                  <div class="selecciona">
                    <ul>
                      <li>
                        <span class="emoticon-number">1</span>
                      </li>
                      <li>
                        <img
                          :src="
                            item.multipleOptionItems[0].emojiType ===
                            'grader_cara_feliz'
                              ? emojiFeliz
                              : item.multipleOptionItems[0].emojiType ===
                                'grader_cara_enojo'
                              ? emojiEnojado
                              : item.multipleOptionItems[0].emojiType ===
                                'grader_cara_neutro'
                              ? emojiIndiferente
                              : item.multipleOptionItems[0].emojiType ===
                                'grader_cara_tristeza'
                              ? emojiTriste
                              : ''
                          "
                          alt
                        />
                      </li>
                      <li>
                        <span
                          @click="showEmoji(1)"
                          class="select-emoticon"
                          :class="{
                            'disabled-class': surveyPercentAnswer !== 0
                          }"
                          >Selecciona emoticon</span
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="sentimiento">
                    <ul>
                      <li>
                        <p>Sentimiento</p>
                      </li>
                      <li>
                        <input
                          type="text"
                          v-model="item.multipleOptionItems[0].name"
                          :disabled="surveyPercentAnswer !== 0"
                        />
                      </li>
                    </ul>
                  </div>
                  <div
                    class="sentimientos-imgs"
                    :class="emojiModal1 ? '' : 'desaparecer'"
                  >
                    <img
                      @click="selectFeeling('grader_cara_feliz', 1, item)"
                      src="@/assets/img/icon/emoticon/feliz.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_enojo', 1, item)"
                      src="@/assets/img/icon/emoticon/enojado.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_neutro', 1, item)"
                      src="@/assets/img/icon/emoticon/indiferente.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_tristeza', 1, item)"
                      src="@/assets/img/icon/emoticon/triste.png"
                      alt
                    />
                  </div>
                </div>
                <div class="sentimiento-section mb-3">
                  <div class="selecciona">
                    <ul>
                      <li>
                        <span class="emoticon-number">2</span>
                      </li>
                      <li>
                        <img
                          :src="
                            item.multipleOptionItems[1].emojiType ===
                            'grader_cara_feliz'
                              ? emojiFeliz
                              : item.multipleOptionItems[1].emojiType ===
                                'grader_cara_enojo'
                              ? emojiEnojado
                              : item.multipleOptionItems[1].emojiType ===
                                'grader_cara_neutro'
                              ? emojiIndiferente
                              : item.multipleOptionItems[1].emojiType ===
                                'grader_cara_tristeza'
                              ? emojiTriste
                              : ''
                          "
                          alt
                        />
                      </li>
                      <li>
                        <span
                          @click="showEmoji(2)"
                          :class="{
                            'disabled-class': surveyPercentAnswer !== 0
                          }"
                          class="select-emoticon"
                          >Selecciona emoticon</span
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="sentimiento">
                    <ul>
                      <li>
                        <p>Sentimiento</p>
                      </li>
                      <li>
                        <input
                          type="text"
                          v-model="item.multipleOptionItems[1].name"
                          :disabled="surveyPercentAnswer !== 0"
                        />
                      </li>
                    </ul>
                  </div>
                  <div
                    class="sentimientos-imgs"
                    :class="emojiModal2 ? '' : 'desaparecer'"
                  >
                    <img
                      @click="selectFeeling('grader_cara_feliz', 2, item)"
                      src="@/assets/img/icon/emoticon/feliz.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_enojo', 2, item)"
                      src="@/assets/img/icon/emoticon/enojado.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_neutro', 2, item)"
                      src="@/assets/img/icon/emoticon/indiferente.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_tristeza', 2, item)"
                      src="@/assets/img/icon/emoticon/triste.png"
                      alt
                    />
                  </div>
                </div>
                <div class="sentimiento-section mb-5">
                  <div class="selecciona">
                    <ul>
                      <li>
                        <span class="emoticon-number">3</span>
                      </li>
                      <li>
                        <img
                          :src="
                            item.multipleOptionItems[2].emojiType ===
                            'grader_cara_feliz'
                              ? emojiFeliz
                              : item.multipleOptionItems[2].emojiType ===
                                'grader_cara_enojo'
                              ? emojiEnojado
                              : item.multipleOptionItems[2].emojiType ===
                                'grader_cara_neutro'
                              ? emojiIndiferente
                              : item.multipleOptionItems[2].emojiType ===
                                'grader_cara_tristeza'
                              ? emojiTriste
                              : ''
                          "
                          alt
                        />
                      </li>
                      <li>
                        <span
                          @click="showEmoji(3)"
                          :class="{
                            'disabled-class': surveyPercentAnswer !== 0
                          }"
                          class="select-emoticon"
                          >Selecciona emoticon</span
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="sentimiento">
                    <ul>
                      <li>
                        <p>Sentimiento</p>
                      </li>
                      <li>
                        <input
                          type="text"
                          v-model="item.multipleOptionItems[2].name"
                          :disabled="surveyPercentAnswer !== 0"
                        />
                      </li>
                    </ul>
                  </div>
                  <div
                    class="sentimientos-imgs"
                    :class="emojiModal3 ? '' : 'desaparecer'"
                  >
                    <img
                      @click="selectFeeling('grader_cara_feliz', 3, item)"
                      src="@/assets/img/icon/emoticon/feliz.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_enojo', 3, item)"
                      src="@/assets/img/icon/emoticon/enojado.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_neutro', 3, item)"
                      src="@/assets/img/icon/emoticon/indiferente.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_tristeza', 3, item)"
                      src="@/assets/img/icon/emoticon/triste.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </b-collapse>
          </b-card>
        </div>
      </div>

      <div
        class="add-question mt-5"
        
        :class="{ 'disabled-class': this.surveyPercentAnswer !== 0 }"
      >
        <div class="add-square">
          <p @click="show">+</p>
        </div>
        <b-dropdown
          id="dropdownMenuButton"
          :text="$t('diagnostic.survey.add_question')"
          class="ml-5 add-question-dropdown"
        >
          <b-dropdown-item @click="openModal('Opción única')"
            >Opción única</b-dropdown-item
          >
          <b-dropdown-item @click="openModal('Switch')">Switch</b-dropdown-item>
          <b-dropdown-item @click="openModal('Calificación')"
            >Calificación</b-dropdown-item
          >
          <b-dropdown-item @click="openModal('Opción múltiple')"
            >Opción múltiple</b-dropdown-item
          >
          <b-dropdown-item @click="openModal('Emoticons')"
            >Emoticons</b-dropdown-item
          >
          <b-dropdown-item @click="openModal('Slider')">Slider</b-dropdown-item>
          <b-dropdown-item @click="openModal('Pregunta abierta')"
            >Pregunta abierta</b-dropdown-item
          >
        </b-dropdown>
      </div>
      

      <div class="validity mt-5">
        <label class="font-b">{{ $t("surveys.newSurvey.expire") }}</label>
        <br />
        <div class="dates">
          <div class="date-from">
            <label for>{{ $t("surveys.newSurvey.from") }} (....*)</label>
            <input
              type="date"
              placeholder="dd/mm/yyyy"
              v-model="date1"
              :min="date1"
              :disabled="this.surveyPercentAnswer !== 0"
            />
          </div>
          <div class="time-from">
            <label for>{{ $t("surveys.newSurvey.time") }} (*)</label>
            <vue-timepicker
              v-model="time1"
              :disabled="this.surveyPercentAnswer !== 0"
            ></vue-timepicker>
          </div>
          <div class="date-to">
            <label for>{{ $t("surveys.newSurvey.to") }} (*)</label>
            <input
              type="date"
              placeholder="dd/mm/yyyy"
              v-model="date2"
              :min="date2"
              :disabled="this.surveyPercentAnswer !== 0"
            />
          </div>
          <div class="time-to">
            <label for>{{ $t("surveys.newSurvey.time") }} (*)</label>
            <vue-timepicker
              v-model="time2"
              :disabled="this.surveyPercentAnswer !== 0"
            ></vue-timepicker>
          </div>
        </div>
        <div class="estimated mt-3">
          <label for>{{ $t("diagnostic.survey.estimated_time") }} (min) (*)</label>
          <input
            type="number"
            v-model="surveyTime"
            :disabled="this.surveyPercentAnswer !== 0"
          />
        </div>
      </div>
    </form>
    <div class="sendNotification">
      <div class="notePush">{{ $t("surveys.newSurvey.notePush") }}</div>
      <div class="notification">
        <label for="notification">
          {{ $t("surveys.newSurvey.notification") }}
        </label>
        <input
          :disabled="this.surveyPercentAnswer !== 0"
          type="checkbox"
          id="notification"
          v-model="sendNotification"
          class="mr-2"
        />
        <!-- <label for="anonymous">
          {{
          $t("surveys.newSurvey.anonymous")
          }}
        </label>
        <input
          :disabled="this.surveyPercentAnswer !== 0"
          type="checkbox"
          id="anonymous"
          v-model="anonymous"
        />-->
      </div>
    </div>
    <div class="footer-buttons">
      <span
        class="control cancel-btn"
        @click="openCancelWarningModal"
        v-if="this.surveyPercentAnswer === 0 && this.$route.params.firstTime"
        >{{ $t("surveys.newSurvey.cancelBtn") }}</span
      >
      <router-link
        class="control cancel-btn"
        v-if="this.surveyPercentAnswer === 0 && !this.$route.params.firstTime"
        :to="{
          name: 'Surveys'
        }"
        >{{ $t("surveys.newSurvey.cancelBtn") }}</router-link
      >
      <router-link
        class="control cancel-btn"
        v-if="$route.params.typeAccion == 'clone'"
        :to="{
          name: 'ListDiagnostic'
        }"
        >{{ $t("surveys.newSurvey.return") }}</router-link
      >

      <button
        v-if="$route.params.surveyType === 'quickSurvey' && this.surveyPercentAnswer === 0"
        type="control button"
        class="btn-save"
        @click="edit(true)"
      >
        {{ $t("surveys.modal.publish") }}*****
      </button>
      <button
        v-if="
          $route.params.typeAccion != 'clone'"
        type="control button"
        class="btn-save"
        @click="buildNormalQuestion(true)"
      >
        {{ $t("surveys.modal.publish") }}
      </button>
    </div>



    
    <!--MODALS-->
    <Modal v-if="modalActive" v-on:closeModal="closeModal">
      <template #header>
        <h6 v-if="questionModal" class="modal-title">
          {{ $t("surveys.modal.newQuestion") }} {{ newQuestionTitle }}-
        </h6>
        <h6 v-if="editModal" class="modal-title">
          {{ $t("surveys.modal.editQuestion") }}
        </h6>
        <h6 v-if="deleteModal" class="modal-title">
          {{ $t("surveys.modal.delQuestion") }}
        </h6>
        <h6 v-if="cancelWarningModal || publishWarningModal" for>
          {{ $t("surveys.modal.cancelWarningTitle") }}
        </h6>
      </template>
      <template>
        <div>
          <label v-if="questionModal || editModal" for>
            {{ $t("surveys.modal.question") }}
          </label>

          <label v-if="deleteModal" for>
            {{ $t("surveys.modal.delQuestionDialog") }}
          </label>
          <input
            v-if="questionModal || editModal"
            type="text"
            v-model="nameQuestion"
          />
          <p v-if="cancelWarningModal">
            {{ $t("surveys.modal.cancelWarningText") }}
          </p>
        </div>
      </template>
      <template>
      <br>
      <div  v-if="questionModal || editModal">
        <label>
          {{ $t("diagnostic.modal.category") }}
        </label>
        <select v-model="categoriQuestion">
          <option v-for="item in newsList" :value="item.id" >{{ item.name }}</option>
        
        </select>
        <p v-if="cancelWarningModal">
          {{ $t("surveys.modal.cancelWarningText") }}
        </p>
      </div>
    </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn" @click="closeModal">{{
            $t("surveys.modal.cancel")
          }}</span>
          <button
            v-if="questionModal"
            type="control button"
            class="btn-save"
            @click="addQuestion"
          >
            {{ $t("surveys.modal.save") }}
          </button>
          <button
            v-if="editModal"
            type="control button"
            class="btn-save"
            @click="editQuestion()"
          >
            {{ $t("surveys.modal.edit") }}
          </button>
          <button
            v-if="deleteModal"
            type="control button"
            class="btn-save"
            @click="removeQuestion()"
          >
            {{ $t("surveys.modal.deleteButton") }}
          </button>

          <button
            v-if="cancelWarningModal && $route.params.surveyType === 'quickSurvey'"
            type="control button"
            class="btn-save"
            @click="edit(false)"
          >
            {{ $t("surveys.modal.continue") }}
          </button>

          <button
            v-if="cancelWarningModal && $route.params.surveyType !== 'quickSurvey'"
            type="control button"
            class="btn-save"
            @click="buildNormalQuestion(false)"
          >
            {{ $t("surveys.modal.continue") }}
          </button>
        </div>
      </template>
    </Modal>
    <Modal v-if="modalActivePublish" v-on:closeModal="closeModalPublish">
    <template #header>
      <span class="title">{{ $t("diagnostic.modal.publish") }}</span>
    </template>
    <!-- Modal body -->
    <template>
      <div class="form-container">
        <!-- Name -->
        <div class="input-container">
          <label for="name">{{ $t("diagnostic.modal.saveTemplate") }}</label>
        </div>

        <div class="radio-btn" >
          <div class="group">
            <input  value="1" type="radio" id="1" name="radio" v-model="istemplate"/>
            <label class="margin" for="1">{{ $t("global.yes") }}</label>
          </div>
          <div class="group">
            <input  value="0" type="radio" id="0" name="radio" v-model="istemplate" />
            <label class="margin" for="0">No</label>
          </div>
        </div>

      </div>
    </template>
    <!-- Modal footer -->
    <template #footer>
      <div class="modal-actions">
        <button type="button" class="btn btn-dark save-btn" @click="saveData()">{{ $t("global.save") }}</button>
      </div>
    </template>
  </Modal>
  <!--MODALS-->
  </div>
</template>

<script>
import Swatches from "vue-swatches";
import API_SERVICE from "@/lib/api/Surveys.js";
import API_SERVICE_DIAGNOSTIC from "@/lib/api/Diagnostic.js";
import moment from "moment";
import momentTimezone from 'moment-timezone';
const Modal = () => import("@/components/Modal");
// Import the styles too, globally
import "vue-swatches/dist/vue-swatches.min.css";
import "vue2-timepicker/dist/VueTimepicker.css";
import VueTimepicker from "vue2-timepicker";

const api = new API_SERVICE();
const api_diagnostic = new API_SERVICE_DIAGNOSTIC();
// Importamos JQuery
const $ = require("jquery");
// Lo declaramos globalmente
window.$ = $;

export default {
  components: {
    Swatches,
    VueTimepicker,
    Modal
  },
  data() {
    return {
      isPublishSurvey:true,
      llave:true,
      newsList: [],
      infoSurvey:{},
      istemplate:0,
      answer1: "",
      answer2: "",
      color1: "",
      color2: "",
      colors: ["#12C464", "#FFAE50", "#36B6FE", "#FF4895"],
      colors2: ["#12C464", "#FFAE50", "#36B6FE", "#FF4895"],
      colors3: ["#12C464", "#FFAE50", "#36B6FE", "#FF4895"],
      time1: "",
      time2: "",
      fastQuestion: "",
      idQuestion: null,
      idAnswer: [],
      from: "",
      to: "",
      surveyTime: 0,
      date1: new Date(),
      date2: new Date(),
      modalActive: false,
      modalActivePublish:false,
      questionModal: false,
      deleteModal: false,
      editModal: false,
      cancelWarningModal: false,
      publishWarningModal: false,
      newQuestionTitle: "",
      multiOptionContador: 0,
      questions: {},
      nameQuestion: "",
      categoriQuestion:0,
      indexQuestion: 0,
      editCurrentKey: "",
      surveyDescription: "",
      emojiType1: "grader_cara_feliz",
      emojiType2: "grader_cara_feliz",
      emojiType3: "grader_cara_feliz",
      emojiNumber: 0,
      emoji1: require("@/assets/img/icon/emoticon/feliz.png"),
      emoji2: require("@/assets/img/icon/emoticon/feliz.png"),
      emoji3: require("@/assets/img/icon/emoticon/feliz.png"),
      emojiModal1: false,
      emojiModal2: false,
      emojiModal3: false,
      surveyTypes: null,
      emojiFeliz: require("@/assets/img/icon/emoticon/feliz.png"),
      emojiTriste: require("@/assets/img/icon/emoticon/triste.png"),
      emojiEnojado: require("@/assets/img/icon/emoticon/enojado.png"),
      emojiIndiferente: require("@/assets/img/icon/emoticon/indiferente.png"),
      isActiveAlert: false,
      users: null,
      sendNotification: false,
      surveyPercentAnswer: 0,
      editSurveyInfo: null,
      anonymous: false,
      notificationId: ""
    };
  },

  methods: {
    saveData:async function(){
      this.$store.commit("global/SET_LOADING", true);
      console.log("=============>",this.istemplate);
      if(this.istemplate=="1"){
       const response=await api_diagnostic.createTemplate(this.$route.params.id);
       console.log("__________>",response);
       
      }
      this.modalActivePublish=false;
      this.$store.commit("global/SET_LOADING", false);
      this.$router.push({
          name: "ListDiagnostic"
      });
        
      
    },
    openModal: function(name) {
      this.modalActive = true;
      this.questionModal = true;
      this.newQuestionTitle = name;
    },
    openDeleteModal: function(index) {
      this.modalActive = true;
      this.deleteModal = true;
      this.editCurrentKey = index;
    },
    openEditModal: function(index, name) {
      console.log(this.questions[index]);
      
      this.categoriQuestion=this.questions[index].categoryId;
      this.modalActive = true;
      this.editModal = true;
      this.editCurrentKey = index;
      this.nameQuestion = name;
    },
    openCancelWarningModal: function() {
      this.modalActive = true;
      this.cancelWarningModal = true;
    },
    openPublishWarningModal: function() {
      this.modalActive = true;
      this.publishWarningModal = true;
    },
    closeModal: function() {
      this.modalActive = false;
      this.questionModal = false;
      this.deleteModal = false;
      this.editModal = false;
      this.cancelWarningModal = false;
      this.publishWarningModal = false;
      this.nameQuestion = "";
    },
    closeModalPublish:function(){
      this.modalActivePublish=false;
    },
    addQuestion: function() {
      let type = this.convertTypeQuestion();
      /*
        Ejemplo de lo que tiene type
        {
        type:"radio_button",
        id_type:""
        }        
      */
      let multipleOptionItems = {};
      let currentIndex = 3;
      if (type.type === "radio_button" || type.type === "multiple_option") {
        multipleOptionItems = {
          0: { name: "" },
          1: { name: "" },
          2: { name: "" }
        };
      } else if (type.type === "binary") { //switch
        multipleOptionItems = {
          0: { name: "" },
          1: { name: "" }
        };
        currentIndex = 2;
      } else if (
        type.type === "range" ||
        type.type === "number" ||
        type.type === "open"
      ) {
        multipleOptionItems = {
          0: { name: "-" }
        };
        currentIndex = 1;
      } else if (type.type === "emoji") {
        multipleOptionItems = {
          0: {
            name: "",
            emojiType: "grader_cara_feliz",
            img: require("../../assets/img/icon/emoticon/feliz.png")
          },
          1: {
            name: "",
            emojiType: "grader_cara_feliz",
            img: require("../../assets/img/icon/emoticon/feliz.png")
          },
          2: {
            name: "",
            emojiType: "grader_cara_feliz",
            img: require("../../assets/img/icon/emoticon/feliz.png")
          }
        };
      }
      console.log("==========questions============>",this.questions);
      const filtro=this.newsList.filter(data=>data.id==this.categoriQuestion);
      console.log("FILTRADO",JSON.stringify(filtro[0].name));
     
      this.questions["question" + this.multiOptionContador] = {
        categoryName:JSON.stringify(filtro[0].name),
        categoryId:this.categoriQuestion,
        id_type: type.id_type,
        index: this.indexQuestion,
        title: this.nameQuestion,
        type: this.newQuestionTitle,
        numberType: type.type,
        multipleOptionItems: multipleOptionItems,
        currentIndex,
        questionType: type.type
      };        
      /*
    question0:  {
  "id_type": "6",
  "index": 0,
  "title": "nueva",
  "type": "Switch",
  "numberType": "binary",
  "multipleOptionItems": {
      "0": {
          "name": ""
      },
      "1": {
          "name": ""
      }
  },
  "currentIndex": 2,
  "questionType": "binary"
}
      */
      this.categoriQuestion=0;
      this.indexQuestion = this.indexQuestion + 1;
      this.multiOptionContador++;
      this.closeModal();
    },
    editQuestion: async function(key) {
      this.$store.commit("global/SET_LOADING", true);
      key = this.editCurrentKey;
      this.questions[key].title = this.nameQuestion;
      const filtro=this.newsList.filter(data=>data.id==this.categoriQuestion);
      this.questions[key].categoryName = filtro[0].name;//aqui
      console.log("=====>",this.categoriQuestion);
      if(this.questions[key].id){
        const resp = await api_diagnostic.updateQuestion(this.questions[key].id,this.questions[key].title,this.categoriQuestion); 
      }
      this.closeModal();
      this.categoriQuestion="";
      this.$store.commit("global/SET_LOADING", false);
    },
    removeQuestion: async function(key) {
      this.$store.commit("global/SET_LOADING", true);
      key = this.editCurrentKey;
      if(this.questions[key].id && this.$route.params.typeAccion != "template"){
        const resp = await api_diagnostic.deleteQuestion(this.questions[key].id); 
      }
      delete this.questions[key];
      this.closeModal();
      this.$store.commit("global/SET_LOADING", false);
    },
    show: function() {
      // console.log(this.questions);
    },
    closeEmoticonsModal: function() {
      this.emojiModal1 = false;
      this.emojiModal2 = false;
      this.emojiModal3 = false;
    },
    buildNormalQuestion: async function(published = false) {
console.log("====>",JSON.parse(JSON.stringify(this.questions))  );
      const keys=Object.keys(JSON.parse(JSON.stringify(this.questions)) );
      let respondidasCompletas=true;
      for(let i=0;i<keys.length;i++){
        if(respondidasCompletas){
        const keysChild=Object.keys(this.questions[keys[i]].multipleOptionItems);
        for(let o=0;o<keysChild.length;o++){
          if(this.questions[keys[i]].multipleOptionItems[keysChild[o]].name == ""){
            respondidasCompletas=false;
            break;
          }
        }
        }else{
          break;
        }
      }
      if( !this.date1 || !this.time1 || !this.date2 ||  !this.time2){
        this.$store.commit("global/SET_ALERT", {
        msg: "Ingresa una vigencia valida a la encuesta",
        show: true,
        type: "error"
      });
      }else if(this.surveyTime < 1){
        this.$store.commit("global/SET_ALERT", {
        msg: "Ingresa un tiempo estimado de la encuesta válido, mínimo 1 minuto",
        show: true,
        type: "error"
      });
      }else if(this.surveyDescription.length < 5){
        this.$store.commit("global/SET_ALERT", {
        msg: "Ingresa una descripción mínima de 5 caracteres",
        show: true,
        type: "error"
      });
      }else if(!respondidasCompletas){
        this.$store.commit("global/SET_ALERT", {
        msg: "Llena corectamente las preguntas de la encuesta",
        show: true,
        type: "error"
      });
      }else if(JSON.parse(JSON.stringify(this.users)).length > 0 && Object.keys(JSON.parse(JSON.stringify(this.questions))).length > 0){

      this.$store.commit("global/SET_LOADING", true);
      //try {

        this.from = `${this.date1} ${this.time1}`;
        this.to = `${this.date2} ${this.time2}`;
        let question = {};
        let questionObj = null;
        let responseQuestion = 0;
        let responseAnswer = 0;
        let answerObj = {};
        /*for (const key in this.questions) {
          questionObj = this.questions[key];

          for (const key2 in questionObj.multipleOptionItems) {
            if (questionObj.multipleOptionItems[key2].name === "") {
              this.isActiveAlert = true;
              window.scrollTo(0, 0);

              return;
            }
          }
        }*/
        let arrayQuestion = [];
        let arrayAnswersQuestion = [];
        let surveyIdData=this.$route.params.id;
        if(this.$route.params.typeTemplate != "normal"){
          console.log("*******ENCUESTA NORMAL************");
          
          let params = {
                  name: this.$route.params.nameDesing,
                  isActive: true,
                  isPublished: false,
              };
          const respCreateSurvey = await api_diagnostic.createSurvey(params);
          surveyIdData=respCreateSurvey.id;
        }
        for (const key in this.questions) {
          arrayAnswersQuestion = [];
          questionObj = this.questions[key];
          console.log("questionObj.id",questionObj);
          
          /*question = {
            question_content: questionObj.title,
            id_type: questionObj.id_type,
            id_surveys: this.$route.params.id,
            status: true,
            question_points: 1
          };*/
          question={
            "action": "create",
            "data": {
              "categoryId": questionObj.categoryId,
              "typeId": questionObj.id_type,
              "surveyId": surveyIdData,
              "content": questionObj.title,
              "points": 1,
              "status": "active",
            }
          }
          if(questionObj.id && this.$route.params.typeTemplate == "normal"){
            question.data.id=questionObj.id;
          }
          console.log(question);
          responseQuestion = await api_diagnostic.createQuestion(question);
          /*if (!questionObj.id) {
            responseQuestion = await api.createQuestion(question);
          } else {
            responseQuestion = { question: { id: questionObj.id } };
          }
          this.questions[key].id = responseQuestion.question.id;*/
          for (const key2 in questionObj.multipleOptionItems) {
            /*answerObj = {
              answer: questionObj.multipleOptionItems[key2].name,
              color: "#",
              id_question: responseQuestion.question.id,
              emojiType: questionObj.multipleOptionItems[key2].emojiType
            };*/
            answerObj={
              "action": "create",
              "data": {
                "questionId": responseQuestion.id,
                "color": "#",
                "content": questionObj.multipleOptionItems[key2].name,
                //"emojiType": questionObj.multipleOptionItems[key2].emojiType
                "emojiType": questionObj.multipleOptionItems[key2].emojiType,
                "id":questionObj.multipleOptionItems[key2].id,
            }
            }
            if(!questionObj.multipleOptionItems[key2].emojiType){
              delete answerObj.data.emojiType;
            }
            if(!questionObj.multipleOptionItems[key2].id || this.$route.params.typeTemplate != "normal"){
              delete answerObj.data.id;
            }
            console.log("Preguntas======",answerObj);
            responseAnswer = await api_diagnostic.createAnswer(answerObj);
            /*if (!questionObj.multipleOptionItems[key2].id) {
              responseAnswer = await api.createAnswer(answerObj);
            } else {
              responseAnswer = {
                dataAnswerQuestion: {
                  id: questionObj.multipleOptionItems[key2].id
                }
              };
            }

            this.questions[key].multipleOptionItems[key2].id = responseAnswer.dataAnswerQuestion.id;
            arrayAnswersQuestion.push({
              idAnswer: responseAnswer.dataAnswerQuestion.id,
              color: "#",
              answer: questionObj.multipleOptionItems[key2].name,
              answerEmojiName: questionObj.multipleOptionItems[key2].name,
              answerEmojiType: questionObj.multipleOptionItems[key2].emojiType
            });*/
          }
          /*arrayQuestion.push({
            idQuestions: responseQuestion.question.id,
            questionContent: this.questions[key].title,
            questionTypes: {
              type: this.questions[key].questionType
            },
            answers: arrayAnswersQuestion
          });*/
        }
        /*
        if (this.users === null) {
          this.users = "*";
        }*/
       //AQUI
       let survey={
          "name":this.$route.params.nameDesing ? this.$route.params.nameDesing : this.infoSurvey.name, // OPTIONAL
          "details": this.surveyDescription, // OPTIONAL
          "assignedUsers": JSON.parse(JSON.stringify(this.users)), // OPTIONAL
          "points": 1, // OPTIONAL
          "validFrom": new Date(this.date1+' '+this.time1+':00').toISOString(), // OPTIONAL
          "validTo": new Date(this.date2+' '+this.time2+':00').toISOString(), // OPTIONAL
          "estimatedTime": this.surveyTime, // OPTIONAL
          "isActive": true, // OPTIONAL
          "isPublished": true // OPTIONAL
      }

      console.log("Resultado encuesta ---->",survey);
      await api_diagnostic.editSurvey(survey,surveyIdData);
      //mandar notificacion
      if(this.sendNotification){
      const data={
        title: this.$route.params.nameDesing ? this.$route.params.nameDesing : this.infoSurvey.name,
        users:JSON.parse(JSON.stringify(this.users)),
        descripcion:this.surveyDescription
      }
      await api_diagnostic.sendNotification(data);
      }
      //fin mandar notificacion
      console.log("========USUARIOS================>",JSON.parse(JSON.stringify(this.users)));
      this.closeModal();
      this.$store.commit("global/SET_LOADING", false);
      if(!this.isPublishSurvey){
        this.modalActivePublish=true;
      }else{
        this.$router.push({
          name: "ListDiagnostic"
        });
      }
      
       /* let survey = {
          idSurvey: this.$route.params.id,
          name: this.$route.params.surveyObj.name,
          details: this.surveyDescription,
          validFrom: this.from,
          validTo: this.to,
          points: "0",
          assignedUsers: this.users,
          surveyEstimatedTime: this.surveyTime,
          surveyPublished: published,
          surveyType: this.$route.params.surveyType,
          surveyActive: published,
          questions: arrayQuestion,
          anonymous: this.anonymous,
          notificationId: this.notificationId
        };

        await api.editSurvey(survey);

        if (this.sendNotification) {
          let params = {
            name: this.$route.params.surveyObj.name,
            assigned_users: this.users,
            notificationId: this.notificationId,
            idSurvey: this.$route.params.id
          };
          api.sendNotification(params);
        }
        this.$router.push({
          name: "List Surveys"
        });
      } catch (error) {
        if (error.data.statusCode === 502 || error.data.statusCode === 504) {
          this.$router.push({
            name: "List Surveys"
          });
          return;
        }
        console.log(error);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();*/
    }else{
      
      this.$store.commit("global/SET_ALERT", {
        msg: "Todos los campos son requeridos",
        show: true,
        type: "error"
      });
      
    }
    },


    showEmoji: function(num) {
      this.emojiNumber = num;
      if (num === 1) {
        this.emojiModal1 = true;
        this.emojiModal2 = false;
        this.emojiModal3 = false;
      } else if (num === 2) {
        this.emojiModal1 = false;
        this.emojiModal2 = true;
        this.emojiModal3 = false;
      } else {
        this.emojiModal1 = false;
        this.emojiModal2 = false;
        this.emojiModal3 = true;
      }
      this.emojiModal = true;
    },
    selectFeeling: function(emoji, numberEmoji, item) {
      let imgEmoji =
        emoji === "grader_cara_enojo"
          ? require("../../assets/img/icon/emoticon/enojado.png")
          : emoji === "grader_cara_feliz"
          ? require("../../assets/img/icon/emoticon/feliz.png")
          : emoji === "grader_cara_neutro"
          ? require("../../assets/img/icon/emoticon/indiferente.png")
          : emoji === "grader_cara_tristeza"
          ? require("../../assets/img/icon/emoticon/triste.png")
          : "";

      let clonado = this.lodash.cloneDeep(this.questions);

      clonado["question" + item.index].multipleOptionItems[
        numberEmoji - 1 + ""
      ] = {
        id:
          clonado["question" + item.index].multipleOptionItems[
            numberEmoji - 1 + ""
          ].id,
        name: "",
        emojiType: emoji,
        img: imgEmoji
      };
      clonado["question" + item.index].v = 1;
      clonado["question" + item.index].currentIndex = item.currentIndex + 1;
      this.questions = clonado;
      this.emojiModal1 = false;
      this.emojiModal2 = false;
      this.emojiModal3 = false;
    },
    fillNormalSurvey: function(obj) {
      if (this.$route.params.controlNumbers) {
        this.users = this.$route.params.controlNumbers;
      } else {
        this.users = obj.assignedUsers;
      }

      this.surveyTime = obj.surveyEstimatedTime;
      console.log('original valid from ', obj.validFrom)
      console.log('original valid to ', obj.validTo)
      console.log('TEST MOMENT ', moment())
      console.log('TEST MOMENT WITH DATE ', moment(obj.validFrom))
      let from = moment(obj.validFrom).format("YYYY-MM-DD");
      let to = moment(obj.validTo).format("YYYY-MM-DD");
      this.date1 = from;
      this.date2 = to;
      console.log('valid from: ', from)
      console.log('valid to: ', to)
      let hourF = momentTimezone(obj.validFrom).format("HH:mm");
      let hourT = momentTimezone(obj.validTo).format("HH:mm");
      this.time2 = hourT;
      this.time1 = hourF;
      console.log('hourF: ', hourF)
      console.log('hourT: ', hourT)
      let question = null;
      let identifyType = {};
      let currentIndex = 0;
      let multipleOptionItems = {};
      let index3 = 0;
      for (let index = 0; index < obj.questions.length; index++) {
        multipleOptionItems = {};
        question = obj.questions[index];
        currentIndex = question.answers.length;
        identifyType = this.getNumberType(question.questionTypes.type);
        for (let index2 = 0; index2 < question.answers.length; index2++) {
          multipleOptionItems[index2] = {
            name: question.answers[index2].answer,
            id: question.answers[index2].idAnswer,
            img: question.answers[index2].img,
            emojiType: question.answers[index2].emojiType
          };
          // multipleOptionItems[index2].id = question.answers[index2].idAnswer;
        }
        this.questions["question" + index] = {
          index: index,
          id: question.idQuestions,
          title: question.questionContent,
          type: identifyType.obj, //Es la leyenda debajo de la pregunta para ident el tipo de preg
          numberType: identifyType.index, // Es el identificador del tipo de pregunta
          multipleOptionItems,
          currentIndex,
          questionType: question.questionTypes.type // es el texto del identificador de pregunta "radio_button"
        };

        index3++;
      }
      this.multiOptionContador = index3;
      this.indexQuestion = index3;
      this.surveyDescription = obj.details;
      this.anonymous = obj.anonymous;
      this.notificationId = obj.notificationId;
    },
    getNumberType: function(str) {
      let arrayTypes = [
        "radio_button",
        "binary",
        "range",
        "multiple_option",
        "emoji",
        "number",
        "open"
      ];

      let obj = {
        1: "Opción única",
        2: "Switch",
        3: "Slider",
        4: "Opción multiple",
        5: "Emoticons",
        6: "Calificación",
        7: "Pregunta abierta"
      };
      let index = arrayTypes.indexOf(str) + 1;
      return { index: str, obj: obj[index] };
    },
    convertTypeQuestion: function() {
      let obj = {
        "Opción única": "radio_button",
        Switch: "binary",
        Calificación: "number",
        "Opción múltiple": "multiple_option",
        Emoticons: "emoji",
        Slider: "range",
        "Pregunta abierta": "open"
      };
      let currentType = obj[this.newQuestionTitle];

      let idType = this.surveyTypes.filter(
        type => type.type === currentType
      );
      let resp = {
        type: currentType, //tipo de encuesta
        id_type: idType[0].id //id del api de tipos de encuestas
      };
      /*
        {
        type:"radio_button",
        id_type:""
        }        
      */
      return resp;
    },

    addMultiOptionInput: function(item) {
      let clonado = this.lodash.cloneDeep(this.questions);
      let index = Object.keys(item.multipleOptionItems);
      let lastKey = +index.pop();
      lastKey++;
      clonado["question" + item.index].multipleOptionItems[lastKey + ""] = {
        name: ""
      };
      clonado["question" + item.index].v = 1;
      clonado["question" + item.index].currentIndex = item.currentIndex + 1;
      this.questions = clonado;
    },
    removeMultiOptionInput: function(index, item) {
      let clonado = this.lodash.cloneDeep(this.questions);
      delete clonado["question" + item.index].multipleOptionItems[index + ""];
      this.questions = clonado;
    },
    disableColor: function() {
      let array = this.colors3.filter(key => key !== this.color2);
      this.colors = array;
    },
    disableColor2: function() {
      let array = this.colors3.filter(key => key !== this.color1);
      this.colors2 = array;
    },
    createQuestion: async function() {
      try {
        let params = {
          question_content: this.fastQuestion,
          id_type: 9,
          id_surveys: this.$route.params.id,
          status: true,
          question_points: 1
        };
        const resp = await api.createQuestion(params);
        this.idQuestion = resp.question.id;
      } catch (error) {
        throw error;
      }
    },
    createAnswer: async function(opcion, color) {
      try {
        let params = {
          answer: opcion,
          color: color,
          id_question: this.idQuestion
        };
        const resp = await api.createAnswer(params);
        this.idAnswer.push(resp.dataAnswerQuestion.id);
      } catch (error) {
        throw error;
      }
    },

    edit: async function(published) {
      this.from = `${this.date1} ${this.time1}`;
      this.to = `${this.date2} ${this.time2}`;
      this.$store.commit("global/SET_LOADING", true);
      try {
        if (this.editSurveyInfo.hasOwnProperty("questions")) {
          if (this.editSurveyInfo.questions.length > 0) {
            await this.editSurvey(published);
          } else {
            await this.createQuestion();
            await this.createAnswer(this.answer1, this.color1);
            await this.createAnswer(this.answer2, this.color2);
            await this.editSurvey(published);
          }
        } else {
          await this.createQuestion();
          await this.createAnswer(this.answer1, this.color1);
          await this.createAnswer(this.answer2, this.color2);
          await this.editSurvey(published);
        }
      } catch (error) {
        throw error;
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();
      }
    },
    editSurvey: async function(isPublished) {
      try {
        let answers = [];
        let questions = [];
        let question = {};

        if (this.$route.params.surveyObj.surveyType === "quickSurvey") {
          if (this.editSurveyInfo.questions && this.editSurveyInfo.questions.length > 0) {
            for (let index = 0; index < this.editSurveyInfo.questions.length; index++) {
              let answer = {
                idAnswer: this.editSurveyInfo.questions[index].answers[0].idAnswer,
                color: this.color1,
                answer: this.answer1
              };
              let answer2 = {
                idAnswer: this.editSurveyInfo.questions[index].answers[1].idAnswer,
                color: this.color2,
                answer: this.answer2
              };
              answers.push(answer);
              answers.push(answer2);
              question = {
                idQuestions: this.editSurveyInfo.questions[index].idQuestions,
                questionContent: this.fastQuestion,
                questionTypes: {
                  type: "binary"
                },
                answers: answers
              };
              questions.push(question);
            }
          } else {
            let answer = {
              idAnswer: this.idAnswer[0],
              color: this.color1,
              answer: this.answer1
            };
            let answer2 = {
              idAnswer: this.idAnswer[1],
              color: this.color2,
              answer: this.answer2
            };
            answers.push(answer);
            answers.push(answer2);
            question = {
              idQuestions: this.idQuestion,
              questionContent: this.fastQuestion,
              questionTypes: {
                type: "binary"
              },
              answers: answers
            };
          }
          questions.push(question);
        }
        // questions.push(question);

        if (this.users === null) {
          this.users = "*";
        }
        let survey = {
          idSurvey: this.$route.params.id,
          name: this.$route.params.surveyObj.name,
          details: this.$route.params.surveyObj.details,
          validFrom: this.from,
          validTo: this.to,
          points: "0",
          assignedUsers: this.users,
          surveyEstimatedTime: this.surveyTime,
          surveyType: "quickSurvey",
          surveyPublished: isPublished,
          surveyActive: isPublished,
          questions: questions,
          anonymous: this.anonymous,
          notificationId: this.notificationId
        };

        console.log('El proceso termina hasta aqui con exito')
        const resp = await api.editSurvey(survey);
        if (this.sendNotification) {
          let params = {
            name: this.$route.params.surveyObj.name,
            assigned_users: this.users,
            notificationId: this.notificationId,
            idSurvey: this.$route.params.id
          };

          const notification = api.sendNotification(params);
        }
        this.$router.push({
          name: "ListDiagnostic"
        });
      } catch (error) {
        if (error.data.statusCode === 502 || error.data.statusCode === 504) {
          this.$router.push({
            name: "ListDiagnostic"
          });
          return;
        }
        console.log(error);
      }
    },
    fillSurvey: function(surveyObj) {
      if (this.$route.params.firstTime) {
        let newDate = new Date();
        let from = moment(newDate).format("YYYY-MM-DD");
        let to = moment(newDate).format("YYYY-MM-DD");
        this.date1 = from;
        this.date2 = to;
        let hourF = moment(newDate).format("HH:mm");
        let hourT = moment(newDate).format("HH:mm");
        this.time2 = hourT;
        this.time1 = hourF;
      }
      let from = moment(surveyObj.validFrom).format("YYYY-MM-DD");
      let to = moment(surveyObj.validTo).format("YYYY-MM-DD");
      this.date1 = from;
      this.date2 = to;

      let hourF = moment(surveyObj.validFrom).format("HH:mm");
      let hourT = moment(surveyObj.validTo).format("HH:mm");
      this.time2 = hourT;
      this.time1 = hourF;

      if (surveyObj.questions && surveyObj.questions.length) {
        const answers = surveyObj.questions[0].answers && surveyObj.questions[0].answers.length ?  surveyObj.questions[0].answers : [];
        this.answer1 =  answers.length ? answers[0].answer : '';
        this.surveyTime = surveyObj.surveyEstimatedTime;
        this.answer2 = answers.length && answers.length > 1 ? answers[1].answer : '';
        this.color1 = answers.length ? answers[0].color : '';
        this.color2 = answers.length && answers.length > 1 ? answers[1].color : '';
        this.fastQuestion = surveyObj.questions[0].questionContent;
      }

      if (this.$route.params.controlNumbers) {
        this.users = this.$route.params.controlNumbers;
      } else {
        this.users = surveyObj.assignedUsers;
      }
      
      this.anonymous = surveyObj.anonymous;
      this.notificationId = surveyObj.notificationId;
    },
    fillSurveyTypes: async function() {
      try {
        //const resp = await api.getAllSurveyTypes();
        const respDiagnosis = await api_diagnostic.getAllSurveyTypes();          
        this.surveyTypes = respDiagnosis.items;
      } catch (error) {
        console.error('Error:');
        console.error('error while getting survey types', error);
      }
    },
    getSurveyInfById: async function() {
      this.$store.commit("global/SET_LOADING", true);

      try {
        const resp = await api.getSurveyById(this.$route.params.id);
        this.editSurveyInfo = resp && resp.surveyInfo && resp.surveyInfo.length ? resp.surveyInfo[0] : {};
      } catch (error) {
        console.error('error while retrieving survey');
        console.error(error);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    }
  },
  computed: {
    recipients: function() {
      return this.$store.getters["users/recipients"];
    },
    getSurveyId: function () {
      const id = this.$route.params.id || '';
      return id;
    }
  },
  async beforeMount() {
    try{
    console.log("PARAMS========>",this.$route.params);
    //await this.getSurveyInfById();
    this.$store.commit("global/SET_LOADING", true);
    const resp = await api_diagnostic.getCategories(); 
  
    this.newsList=resp.data.items;

    if(this.$route.params.typeTemplate != "normal"){
      console.log("======>PLANTILLA");
      this.infoSurvey=await api_diagnostic.getTemplatesById(this.$route.params.typeTemplate);
      this.infoSurvey.assignedUsers=[];
      for(let i =0;i< this.infoSurvey.questions.length; i++){
        this.infoSurvey.questions[i].type.type=this.infoSurvey.questions[i].type.name;
      }
    }else{
      console.log("======>NORMAL");
      
      this.infoSurvey=await api_diagnostic.surveyById(this.$route.params.id);
      console.log("=====JJJJJJ",this.infoSurvey.isPublished);
      this.isPublishSurvey=this.infoSurvey.isPublished;
      
    }
    
    
/////////
console.log("info==>",this.infoSurvey);
if(this.$route.params.questionsData && Object.keys(this.$route.params.questionsData).length > 0){
//this.questions=this.$route.params.questionsData;
//this.multiOptionContador=Number(Object.keys(this.$route.params.questionsData)[Object.keys(this.$route.params.questionsData).length-1].replace('question',''));
this.questions = this.$route.params.questionsData;
    
    let index3 = 0;
    for (let index = 0; index < Object.keys(this.$route.params.questionsData).length; index++) {
      index3++;
    }
    this.multiOptionContador = index3;
    this.indexQuestion = index3;

}else if (this.infoSurvey.questions.length >0){
let question = null;
    let identifyType = {};
    let currentIndex = 0;
    let multipleOptionItems = {};
    let index3 = 0;
    for (let index = 0; index < this.infoSurvey.questions.length; index++) {
      multipleOptionItems = {};
      question = this.infoSurvey.questions[index];
      currentIndex = question.answers.length;
      
      identifyType = this.getNumberType(question.type.type);
      for (let index2 = 0; index2 < question.answers.length; index2++) {
        multipleOptionItems[index2] = {
          name: question.answers[index2].content,
          //id: question.answers[index2].id,
          //img: question.answers[index2].img || "",
          //emojiType: question.answers[index2].answerEmojiType || ""
          "emojiType": question.answers[index2].emojiType,
          id: question.answers[index2].id
        };
        if(!question.answers[index2].emojiType){
              delete multipleOptionItems[index2].emojiType ;
        }
        if(!question.answers[index2].id || this.$route.params.typeTemplate != "normal"){
              delete multipleOptionItems[index2].id ;
        }
        console.log("RESPONSE=========>",multipleOptionItems[index2]);
        
         //multipleOptionItems[index2].id = question.answers[index2].idAnswer;
      }
      console.log("************>>>>>>>>>",question);
      this.questions["question" + index] = {
        categoryName:question.category.name,
        categoryId:question.category.id,
        id_type: question.type.id,///falta
        index: index,
        title: question.content,
        type: identifyType.obj, 
        //id: question.id,
        numberType: identifyType.index, 
        multipleOptionItems,
        currentIndex,
        questionType: question.type.type ,
        id:question.id || null
      };

      console.log("data new ",this.questions["question" + index]);
      

      /**
       this.questions["question" + this.multiOptionContador] = {
        categoryId:this.categoriQuestion,
        id_type: type.id_type,
        index: this.indexQuestion,
        title: this.nameQuestion,
        type: this.newQuestionTitle,
        numberType: type.type,
        multipleOptionItems: multipleOptionItems,
        currentIndex,
        questionType: type.type
      };
       */

      index3++;
    }
    this.multiOptionContador = index3;
    this.indexQuestion = index3;
  }
    ////////

    const usersData=this.$route.params.controlNumbers ? JSON.parse(JSON.stringify(this.$route.params.controlNumbers)) : [];
    const usuariosAsignados=JSON.parse(JSON.stringify(this.infoSurvey.assignedUsers));
    this.users=this.$route.params.controlNumbers ? JSON.parse(JSON.stringify(this.$route.params.controlNumbers)) : [...usuariosAsignados];
    this.surveyDescription=this.$route.params.surveyDescription ? this.$route.params.surveyDescription : this.infoSurvey.details;
    this.surveyTime=this.$route.params.surveyTime ? this.$route.params.surveyTime : this.infoSurvey.estimatedTime;
    console.log("template==========",this.$route.params.typeTemplate);
  if(this.$route.params.typeTemplate == "normal"){
    if(this.$route.params.date1 ){
      this.date1 = this.$route.params.date1;
      this.date2 = this.$route.params.date2;
      this.time2 = this.$route.params.time2;
      this.time1 = this.$route.params.time1;
    }else{
    if(this.infoSurvey.validFrom && this.infoSurvey.validTo ){
      let from = moment(this.infoSurvey.validFrom).format("YYYY-MM-DD");
      let to = moment(this.infoSurvey.validTo).format("YYYY-MM-DD");
      this.date1 = from;
      this.date2 = to;
    }else{
      let from = moment(new Date()).format("YYYY-MM-DD");
      let to = moment(new Date()).format("YYYY-MM-DD");
      this.date1 = from;
      this.date2 = to;
    }

    if(this.infoSurvey.validFrom && this.infoSurvey.validTo){
      let hourF = momentTimezone(this.infoSurvey.validFrom).format("HH:mm");
      let hourT = momentTimezone(this.infoSurvey.validTo).format("HH:mm");
      this.time2 = hourT;
      this.time1 = hourF;
    }else{
      let hourF = momentTimezone().format("HH:mm");
      let hourT = momentTimezone().format("HH:mm");
      this.time2 = "23:59";
      this.time1 = hourF;
    }
  }
}else{
      let from = moment(new Date()).format("YYYY-MM-DD");
      let to = moment(new Date()).format("YYYY-MM-DD");
      this.date1 = from;
      this.date2 = to;
      
      let hourF = momentTimezone().format("HH:mm");
      let hourT = momentTimezone().format("HH:mm");
      this.time2 = "23:59";
      this.time1 = hourF;
  }
    
    
    await this.fillSurveyTypes();
    this.$store.commit("global/SET_LOADING", false);
  }catch(err){
    this.$router.push({
          name: "ListDiagnostic"
      });
    }
  },
  mounted() {
    /*if (this.$route.params.survey) {
      this.fastQuestion = this.$route.params.survey.fastQuestion;
      this.surveyDescription = this.$route.params.survey.surveyDescription;
      this.answer1 = this.$route.params.survey.answer1;
      this.color1 = this.$route.params.survey.color1;
      this.answer2 = this.$route.params.survey.answer2;
      this.color2 = this.$route.params.survey.color2;
      this.date1 = this.$route.params.survey.date1;
      this.time1 = this.$route.params.survey.time1;
      this.date2 = this.$route.params.survey.date2;
      this.time2 = this.$route.params.survey.time2;
      this.surveyTime = this.$route.params.survey.surveyTime;
      this.sendNotification = this.$route.params.survey.sendNotification;
      this.questions = this.$route.params.survey.questions;
      this.notificationId = this.$route.params.survey.notificationId;
    }*/

    if (this.$route.params.surveysEnded) {
      this.surveyPercentAnswer = this.$route.params.surveysEnded ;
    }else{
      this.surveyPercentAnswer = 0;
    }
  }
};
</script>

<style>
.margin{
margin: 0 !important;
margin-left: 5px;
margin-right: 5px;
}
.modal-actions{
display: flex;
justify-content: center;
}
.radio-btn {
width: 100%;
display: flex;
flex-direction: row;
justify-content: space-around;
}
.radio-btn .group {
display: flex;
align-items: center;
}

.title {
font-weight: bold;
font-size: 1.2rem;
}
.fast-survey .return {
  color: black;
  cursor: pointer;
}
.fast-survey .return:hover {
  text-decoration: underline !important;
}
</style>
<style lang="scss">
.estimated {
  width: 40%;
}
.sendNotification {
  width: 50%;
  position: relative;
}
.sendNotification .notification {
  width: 100%;
  // display: flex;
  // align-items: center;
  // position: absolute;
  // left: 80%;
  text-align: right;
}
.sendNotification .notification input[type="checkbox"] {
  margin-left: 1rem;
}
.sendNotification > .notePush {
  margin-top: 3em;
  margin-bottom: 1em;
  text-align: right;
}

.gray {
  color: #666666;
  @extend %audi;
}
.vs-collapse {
  background: #fff !important;
  border-radius: 0px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  position: relative;
  z-index: 0;
}
.vs-collapse .card-header {
  background: #fff;
  border-bottom: 0px !important;
  @extend %audi-b;
  cursor: pointer;
  width: 92%;
}
.vs-collapse .icons {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}
.vs-collapse .icons i {
  margin-left: 0.5rem;
  font-size: 1rem;
  margin-right: 0.5rem;
  margin-top: 0.5rem;
  z-index: 1;
  cursor: pointer;
}
.vs-collapse .multiple {
  display: flex;
  flex-direction: column;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  padding: 1rem;
}
.disabled-class {
  pointer-events: none;
  cursor: not-allowed;
}
.vs-collapse .multiple .input-option {
  position: relative;
  margin-bottom: 0.5rem;
}
.remove-opt {
  margin-left: 1rem;
  cursor: pointer;
  @extend %audi-b;
  &:hover {
    color: #bb0a30;
  }
}
#alert {
  width: 50%;
}
.vs-collapse .multiple .input-option i {
  width: 15px;
  height: 15px;
  position: absolute;
  top: 50%;
  left: -7%;
  color: #d9d9d9;
}
.vs-collapse .remove {
  cursor: pointer;
}
.vs-collapse .add-option {
  text-align: center;
  margin-bottom: 1rem;
}
.vs-collapse .add-option span {
  cursor: pointer;
}
.vs-collapse .switch {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 3rem;
  margin-left: 1rem;
  align-items: center;
  position: relative;
}
.vs-collapse .switch .img {
  position: absolute;
  left: 40%;
  top: 60%;
}
.vs-collapse .emoticons {
  display: flex;
  flex-direction: column;
}
.vs-collapse .emoticons .sentimiento-section {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.vs-collapse .emoticons .selecciona {
  display: flex;
  flex-direction: row;
  width: 50%;
}
.vs-collapse .emoticons .sentimiento-section .sentimientos-imgs {
  width: 20%;
  border: 3px solid #333333;
  flex-wrap: wrap;
  text-align: center;
  position: absolute;
  left: 29%;
  background: #ffff;
}
.vs-collapse .emoticons .sentimiento-section .sentimientos-imgs img {
  width: 40%;
  cursor: pointer;
}

.vs-collapse .emoticons .selecciona ul {
  display: inline-flex;
  list-style: none;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.vs-collapse .emoticons .selecciona ul .emoticon-number {
  @extend %audi-b;
  font-size: 2rem;
  margin-left: 0.3rem;
}
.vs-collapse .emoticons .selecciona ul .select-emoticon {
  @extend %audi;
  font-size: 0.9rem;
  cursor: pointer;
}

.vs-collapse .emoticons .selecciona ul li img {
  width: 40%;
}
.vs-collapse .emoticons .sentimiento {
  width: 40%;
  margin-left: 3rem;
}
.vs-collapse .emoticons .sentimiento ul {
  list-style: none;
}
.vs-collapse .emoticons .sentimiento ul li p {
  @extend %audi;
  font-size: 1rem;
}
.vs-collapse .switch .input-option {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.vs-collapse .switch .input-option input {
  width: 70% !important;
}
.vs-collapse .open-question {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}
.vs-collapse .open-question .text-area-option label {
  @extend %audi;
  font-size: 1rem;
}
.vs-collapse .open-question .text-area-option textarea {
  @extend %audi;
  font-size: 1rem;
  border: 1px solid #b3b3b3;
  width: 60%;
  max-height: 120px;
}
.vs-collapse .stars {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}
.vs-collapse .stars img {
  width: 45%;
  margin-bottom: 1rem;
}
.vs-collapse-item--header {
  position: relative;
  @extend %audi-b;
}
.vs-collapse-item--icon-header {
  top: 95%;
  right: 50% !important;
}
.fast-survey form {
  width: 50%;
}
.desaparecer {
  display: none;
}

.fast-survey .options {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
}
.fast-survey .font-b {
  @extend %audi-b;
}
.fast-survey .add-question {
  display: flex;
}
.fast-survey .add-question .add-square {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 50px;
  height: 50px;
  background-color: #333333;
}
.fast-survey .add-question .add-square p {
  color: white;
  @extend %audi;
  font-size: 40px;
  margin-top: 10px;
}
.fast-survey .add-question #dropdownMenuButton > button {
  background-color: #333333;
  border-radius: 0px;
  color: #fff;
  @extend %audi;
  height: 50px;
  width: 10rem;
  &::after {
    content: "";
    display: none;
  }
}
.fast-survey .add-question #dropdownMenuButton > button[aria-expanded="true"] {
  color: #666666;
}
.fast-survey .add-question #dropdownMenuButton > ul {
  border-radius: 0px;
  text-align: left;
  @extend %audi;
  top: -3px !important;
}
.fast-survey .add-question #dropdownMenuButton .dropdown-item.active,
.dropdown-item:active {
  background-color: #333333;
}
.fast-survey .validity .dates {
  display: flex;
  align-items: center;
}
.fast-survey .validity .dates .date-from,
.fast-survey .validity .dates .date-to {
  display: flex;
  flex-direction: column;
  width: 40%;
}
.fast-survey .validity .dates .time-from,
.fast-survey .validity .dates .time-to {
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
}
.vue__time-picker {
  margin-top: -7px;
}
.fast-survey .validity .dates .date-to {
  margin-left: 3rem;
}
.fast-survey .footer-buttons {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 2rem;
}
.fast-survey .control {
  margin-left: 15px;
  font-size: 16px;
  cursor: pointer;
}
.fast-survey .cancel-btn {
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  margin-left: 15px;
  color: #000;
  text-decoration: none;
}
.fast-survey .cancel-btn:hover {
  text-decoration: underline;
}
.fast-survey .btn-save {
  font-family: "audi-bold";
  color: #fff;
  background-color: #000;
  border-color: #000;
  padding: 10px 20px;
  border-radius: 0px;
  border: none;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  margin-left: 15px;
  &:hover {
    background-color: #bb0a30;
    border-color: #bb0a30;
  }
}
</style>
